﻿﻿export interface IEmailFlagGroup {
    id: number;
    groupName: string;
    sortOrder: number;
}
